import m from '@bitstillery/mithril'
import {classes} from '@bitstillery/common/lib/utils'
import {PanelLeft} from '@bitstillery/common/components'
import {Button} from '@bitstillery/common/components'
import {activated_filters} from '@bitstillery/common/lib/filters'
import {$s, store, view} from '@bitstillery/common/app'

export class PanelMenu extends PanelLeft {
    override className = 'c-panel-menu'

    override slot_toggles() {
        const filters_activated = view.collection ? activated_filters(view.collection) : 0
        return [
            $s.env.layout === 'desktop' ? (
                <Button
                    className={classes('toggle', 'panel-left-toggle', {
                        [$s.panels.left.collapsed ? 'collapsed' : 'uncollapsed']: true,
                    })}
                    icon={$s.panels.left.collapsed ? 'menuOpen' : 'chevronLeft'}
                    onclick={(e) => {
                        e.stopPropagation()
                        $s.panels.left.collapsed = !$s.panels.left.collapsed
                        // In tablet/mobile mode, the panels and their toggles move to the left.
                        // When toggling this button/panel, the other panels act as an accordion.
                        if (['mobile', 'tablet'].includes($s.env.layout)) {
                            $s.panels.view.filters.collapsed = true
                            $s.panels.view.categories.collapsed = true
                        }

                        if ($s.env.layout === 'mobile') {
                            $s.panels.context.collapsed = true
                            $s.panels.view.menu.collapsed = true
                        }
                        void store.save()
                    }}
                    variant='toggle'
                />
            ) : null,
            ['mobile', 'tablet'].includes($s.env.layout) ? (
                <Button
                    className={classes('toggle', 'panel-view-categories', {
                        active: !$s.panels.view.categories.collapsed,
                    })}
                    icon='categories'
                    onclick={(e) => {
                        e.stopPropagation()
                        $s.panels.left.collapsed = true
                        $s.panels.view.filters.collapsed = true
                        $s.panels.view.categories.collapsed = !$s.panels.view.categories.collapsed

                        if ($s.env.layout === 'mobile') {
                            $s.panels.context.collapsed = true
                            $s.panels.view.menu.collapsed = true
                        }
                    }}
                    variant='toggle'
                />
            ) : null,
            ['mobile', 'tablet'].includes($s.env.layout) && view.collection && Object.keys(view.collection.filters).length > 0 ? (
                <Button
                    className={classes('toggle', 'panel-view-filters', {
                        active: !$s.panels.view.filters.collapsed,
                        selection: filters_activated > 0,
                    })}
                    icon='filter'
                    onclick={(e) => {
                        e.stopPropagation()
                        $s.panels.view.categories.collapsed = true
                        $s.panels.view.filters.collapsed = !$s.panels.view.filters.collapsed
                        $s.panels.left.collapsed = true
                        if ($s.env.layout === 'mobile') {
                            $s.panels.context.collapsed = true
                            $s.panels.view.menu.collapsed = true
                        }
                    }}
                    text={filters_activated > 0 ? String(filters_activated) : undefined}
                    type='default'
                    variant='toggle'
                >
                    {filters_activated > 0 && <div className='amount'>{filters_activated}</div>}
                </Button>
            ) : null,
            $s.env.layout === 'mobile' && $s.panels.context.active ? (
                <Button
                    className={classes('toggle', 'panel-view-context', {
                        active: !$s.panels.context.collapsed,
                    })}
                    icon={'context'}
                    onclick={(e) => {
                        e.stopPropagation()
                        $s.panels.context.collapsed = !$s.panels.context.collapsed
                        $s.panels.view.filters.collapsed = true
                        $s.panels.view.categories.collapsed = true
                        $s.panels.left.collapsed = true
                        $s.panels.view.menu.collapsed = true
                    }}
                    type='default'
                    variant='toggle'
                />
            ) : null,
        ]
    }
}
